{
  "flame": {
    "title": "Пламя Любви",
    "currentStreakLabel": "ТЕКУЩИЙ СТРИК",
    "streakDays_one": "{{count}} день подряд",
    "streakDays_few": "{{count}} дня подряд",
    "streakDays_many": "{{count}} дней подряд",
    "status": {
      "firstDay": "Выполни первую практику и зажги Пламя",
      "atRisk": "Практика сегодня ещё не выполнена",
      "milestone": "Новая веха достигнута!",
      "done": "Практика сегодня выполнена",
      "neutral": "Поддержи Пламя сегодняшней практикой"
    },
    "statusLost_one": "Пламя затухло · лучший стрик {{count}} день",
    "statusLost_few": "Пламя затухло · лучший стрик {{count}} дня",
    "statusLost_many": "Пламя затухло · лучший стрик {{count}} дней",
    "nextMilestone": {
      "label": "Следующая веха",
      "remaining_one": "осталось {{count}} день",
      "remaining_few": "осталось {{count}} дня",
      "remaining_many": "осталось {{count}} дней",
      "fallbackName_one": "{{count}} день",
      "fallbackName_few": "{{count}} дня",
      "fallbackName_many": "{{count}} дней"
    },
    "cta": {
      "practice": "Выполнить практику",
      "relight": "Зажечь Пламя снова"
    },
    "risk": {
      "title": "Пламя под угрозой",
      "subtitle": "Сегодня ещё не было практики — Пламя может затухнуть до полуночи."
    },
    "success": {
      "done": "Практика выполнена",
      "milestone": "Новая веха достигнута",
      "subtitle": "Пламя Любви защищено до завтра"
    },
    "a11y": {
      "info": "Что такое Пламя Любви?",
      "share": "Поделиться Пламенем Любви",
      "practice": "Выполнить практику",
      "art": "Пламя Любви"
    },
    "state": {
      "loadingA11y": "Загружаем Пламя Любви",
      "errorMessage": "Не удалось загрузить Пламя Любви. Попробуй ещё раз.",
      "retry": "Повторить",
      "retryA11y": "Повторить загрузку Пламени Любви"
    }
  },
  "flameInfo": {
    "title": "Что такое Пламя Любви?",
    "intro": "Пламя Любви — это твой стрик, который показывает, сколько дней подряд ты поддерживаешь связь с собой через практику.",
    "close": "Закрыть",
    "scrimA11y": "Закрыть пояснение о Пламени Любви",
    "eyebrowLost": "СТРИК ПОТЕРЯН",
    "share": "Поделиться",
    "shareA11y": "Поделиться Пламенем Любви",
    "brandTitle": "ПЛАМЯ ЛЮБВИ",
    "streakLabel": "дней подряд",
    "dayUnit": "день",
    "allMilestonesReached": "Все вехи достигнуты",
    "milestoneReached": "Следующая веха достигнута",
    "progressLabelA11y": "Прогресс до следующей вехи",
    "rows": {
      "days": {
        "title": "Дни подряд",
        "description": "Текущее количество дней, когда ты хотя бы раз в день выполнил практику. Для продления стрика достаточно одного действия в день."
      },
      "flame": {
        "title": "Пламя",
        "description": "Символ твоего стрика. Пока ты практикуешь каждый день — Пламя горит. Если пропустишь день, оно начнёт затухать."
      },
      "next": {
        "title": "Следующая веха",
        "description": "Каждая веха — это важный рубеж на твоём пути. Достигай их, чтобы получать достижения и награды.",
        "allDone": "Все доступные вехи достигнуты."
      },
      "milestone": {
        "titleFallback": "Следующая веха",
        "description": "Название следующей вехи на твоём пути. Оно показывает этап развития твоей привычки."
      },
      "remaining": {
        "title_one": "Осталось {{count}} день",
        "title_few": "Осталось {{count}} дня",
        "title_many": "Осталось {{count}} дней",
        "reached": "Следующая веха достигнута",
        "description": "Сколько дней осталось до следующей вехи. Следи за прогрессом и приближайся к ней."
      },
      "progress": {
        "title": "Прогресс ({{percent}}%)",
        "description": "Показывает, насколько ты продвинулся к следующей вехе. Чем больше дней — тем ближе награда."
      }
    },
    "status": {
      "firstDay": {
        "title": "Пламя ещё не зажжено",
        "description": "Выполни первую практику сегодня, чтобы зажечь свой огонь."
      },
      "atRisk": {
        "title": "Пламя под угрозой",
        "description": "Сегодня практики ещё не было — Пламя может затухнуть до полуночи."
      },
      "done": {
        "title": "Практика выполнена!",
        "description": "Пламя Любви защищено до завтра."
      },
      "milestone": {
        "title": "Новая веха достигнута!",
        "description": "Пламя Любви защищено, а новая награда уже открыта."
      },
      "neutral": {
        "title": "Пламя горит",
        "description": "Практикуй сегодня, чтобы поддержать огонь и сохранить стрик."
      },
      "lost": {
        "title": "Пламя затухло",
        "description": "Счётчик дней обнулился — путь к следующей вехе начинается заново. Свет Души сохраняется."
      }
    },
    "a11y": {
      "flameLost": "Пламя Любви затухло",
      "flameBurning": "Пламя Любви горит"
    }
  },
  "achievements": {
    "title": "Достижения",
    "summaryTitle": "Твои достижения",
    "summaryCounter": "{{earned}} из {{total}}",
    "summarySubtitle": "Следи за своим путём и открывай новые бейджи.",
    "tabs": {
      "earned": "Полученные",
      "inProgress": "В процессе",
      "future": "Будущие"
    },
    "status": {
      "earned": "Получено",
      "earnedAt": "Получено {{date}}",
      "progress": "Прогресс: {{current}}/{{target}}",
      "inProgress": "В процессе",
      "locked": "Ещё не открыто"
    },
    "reward": {
      "title": "Награда за достижение",
      "line1": "Бейдж добавляется в коллекцию.",
      "line2": "Дополнительный XP не начисляется."
    },
    "empty": {
      "earned": "Пока нет полученных достижений. Первые появятся после важных шагов на Пути Света.",
      "inProgress": "Сейчас нет достижения в процессе. Начни практиковать, чтобы приблизиться к следующей вехе.",
      "future": "Все доступные достижения уже открыты."
    },
    "a11y": {
      "back": "Назад",
      "info": "Что такое достижения?",
      "tab": "{{label}}, {{count}}",
      "card": "{{name}}. {{condition}}. {{status}}"
    },
    "state": {
      "loadingA11y": "Загружаем достижения",
      "errorTitle": "Не удалось загрузить достижения",
      "errorMessage": "Попробуй ещё раз.",
      "offlineTitle": "Нет соединения",
      "offlineMessage": "Достижения появятся, когда связь вернётся.",
      "retry": "Повторить",
      "retryA11y": "Повторить загрузку достижений"
    },
    "unknown": {
      "name": "Неизвестное достижение",
      "description": "Оно появится после обновления приложения."
    }
  },
  "achievementsInfo": {
    "title": "Что такое достижения?",
    "intro": "Достижения — это важные вехи на твоём пути. Они отмечают твои успехи, вдохновляют двигаться дальше и делают путь ещё более осознанным и радостным.",
    "close": "Закрыть",
    "scrimA11y": "Закрыть пояснение о достижениях",
    "rows": {
      "earned": {
        "title": "Полученные",
        "description": "Уже открытые бейджи."
      },
      "inProgress": {
        "title": "В процессе",
        "description": "Достижения, к которым ты сейчас продвигаешься."
      },
      "future": {
        "title": "Будущие",
        "description": "Достижения, выполнение которых ещё не начато."
      }
    },
    "reward": "За достижение выдаётся бейдж; дополнительный XP не начисляется."
  },
  "soulLightInfo": {
    "title": "Что такое Свет Души?",
    "intro": "Свет Души — это опыт, который отражает твою активность и прогресс на платформе.",
    "close": "Закрыть",
    "scrimA11y": "Закрыть пояснение о Свете Души",
    "note": "На первом этапе XP показывает твой прогресс и не тратится.",
    "unavailable": "Данные о прогрессе пока не загрузились.",
    "rows": {
      "currentXp": {
        "title": "Текущий XP",
        "description": "Показывает, сколько опыта ты уже накопил.",
        "value": "{{xp}} XP"
      },
      "nextLevel": {
        "title": "Следующий уровень",
        "description": "Сейчас ты движешься к уровню «{{level}}».",
        "unknown": "Следующий уровень откроется по мере роста.",
        "max": "Ты на максимальном уровне."
      },
      "progress": {
        "title": "Прогресс — {{percent}}%",
        "titlePlain": "Прогресс",
        "description": "До следующего уровня осталось {{remaining}} XP.",
        "max": "Все уровни пути уже открыты.",
        "a11y": "Прогресс до следующего уровня"
      },
      "sources": {
        "title": "Источники XP",
        "practices": "Практики",
        "lives": "Live",
        "media": "Медиа",
        "comments": "Комментарии",
        "other": "Другое"
      },
      "recent": {
        "title": "Последние начисления",
        "description": "Здесь видны реальные активности и полученный за них опыт."
      },
      "more": {
        "title": "Как получать больше",
        "description": "Практикуй, участвуй в Live, смотри медиа и общайся."
      }
    }
  },
  "levelInfo": {
    "title": "Что такое уровень духовного пути?",
    "intro": "Уровень отражает общий прогресс в Agapella. Получай Свет Души и открывай новые ступени пути.",
    "close": "Закрыть",
    "scrimA11y": "Закрыть пояснение об уровне духовного пути",
    "tabs": {
      "levels": "Уровни",
      "rewards": "Награды и возможности",
      "a11y": "Разделы пояснения"
    },
    "levelNames": {
      "seeker": "Искатель",
      "keeper": "Хранитель",
      "master": "Проводник света",
      "grand_master": "Магистр света"
    },
    "current": {
      "eyebrow": "Текущий уровень",
      "chip": "Текущий",
      "xp": "{{xp}} XP",
      "unknown": "Ступень пока не определена"
    },
    "next": {
      "toLevel": "До уровня «{{name}}» · {{remaining}} XP",
      "toLevelPlain": "До уровня «{{name}}»",
      "summitTitle": "Высшая ступень",
      "summitDescription": "Ты прошёл весь путь — впереди только глубина практики."
    },
    "progress": {
      "value": "{{percent}}%",
      "a11y": "Прогресс до следующего уровня"
    },
    "ladder": {
      "title": "Лента уровней",
      "threshold": "{{xp}} XP",
      "state": {
        "passed": "Пройден",
        "current": "Текущий",
        "next": "Следующий",
        "summit": "Высшая ступень",
        "future": "Впереди"
      }
    },
    "growth": {
      "title": "Как растёт уровень",
      "description": "Уровень растёт вместе с накопленным Светом Души. Продолжай свой путь, чтобы открывать новые ступени."
    },
    "rewards": {
      "title": "Что открывает каждый уровень",
      "items": {
        "seeker": {
          "1": "Доступ к Пути Света.",
          "2": "Первые достижения.",
          "3": "Отслеживание личного прогресса."
        },
        "keeper": {
          "1": "Возможность создать собственное сообщество.",
          "2": "Новые достижения и награды.",
          "3": "Участие в развитии сообществ Agapella."
        },
        "master": {
          "1": "Расширенные возможности проведения Live-сессий.",
          "2": "Расширенные возможности управления собственным сообществом.",
          "3": "Доступ к специальным материалам и событиям."
        },
        "grand_master": {
          "1": "Возможность стать помощником мастера.",
          "2": "Возможность получить права модератора по приглашению мастера или владельца сообщества.",
          "3": "Участие в развитии платформы.",
          "4": "Особые события и награды Agapella."
        }
      }
    },
    "state": {
      "unavailable": "Данные о прогрессе пока не загрузились.",
      "retry": "Повторить",
      "retryA11y": "Повторить загрузку уровня"
    },
    "a11y": {
      "rung": "{{name}}. {{state}}",
      "rungWithXp": "{{name}}, {{xp}}. {{state}}"
    }
  },
  "personalRecordsInfo": {
    "title": "Что такое Личные рекорды?",
    "intro": "Здесь собраны четыре показателя твоего прогресса в Agapella.",
    "close": "Закрыть",
    "scrimA11y": "Закрыть пояснение о Личных рекордах",
    "banner": {
      "title": "Твой путь — в твоём темпе",
      "subtitle": "Каждый шаг имеет значение"
    },
    "closing": "Ты на своём пути, и каждый шаг имеет значение.",
    "xpUnit": "XP",
    "dayForms": {
      "one": "день",
      "few": "дня",
      "many": "дней"
    },
    "records": {
      "streak": {
        "title": "Максимальный стрик",
        "description": "Самая длинная серия дней подряд с выполненной практикой."
      },
      "practices": {
        "title": "Завершённые практики",
        "description": "Общее количество завершённых практик."
      },
      "lives": {
        "title": "Посещённые Live",
        "description": "Общее количество посещённых Live-сессий."
      },
      "xp": {
        "title": "Всего XP",
        "description": "Текущий объём Света Души (XP)."
      }
    },
    "a11y": {
      "row": "{{title}}: {{value}}. {{description}}",
      "unavailable": "значение недоступно"
    }
  },
  "milestonesInfo": {
    "title": "Что такое Вехи пути?",
    "intro": "Вехи пути — это важные точки твоего Пламени Любви. Поддерживай серию ежедневных практик, чтобы проходить их одну за другой.",
    "close": "Закрыть",
    "scrimA11y": "Закрыть пояснение о Вехах пути",
    "listTitle": "Вехи пути",
    "note": "Каждая достигнутая веха открывает одноимённое достижение. Бейдж добавляется в твою коллекцию.",
    "days_one": "{{count}} день подряд",
    "days_few": "{{count}} дня подряд",
    "days_many": "{{count}} дней подряд",
    "summary": {
      "currentStreak": "Текущая серия",
      "nextMilestone": "Следующая веха",
      "progress_one": "{{current}} из {{count}} дня",
      "progress_few": "{{current}} из {{count}} дней",
      "progress_many": "{{current}} из {{count}} дней",
      "remaining_one": "Осталось {{count}} день",
      "remaining_few": "Осталось {{count}} дня",
      "remaining_many": "Осталось {{count}} дней",
      "allDone": "Все вехи пройдены",
      "allDoneDescription": "Ты прошёл все вехи Пламени Любви. Продолжай серию — она остаётся с тобой.",
      "unknownStreak": "Серия пока не загрузилась"
    },
    "status": {
      "earned": "Получено",
      "inProgress": "В процессе",
      "future": "Будущая"
    },
    "state": {
      "errorTitle": "Не удалось загрузить Вехи пути",
      "errorMessage": "Попробуй ещё раз.",
      "retry": "Повторить",
      "retryA11y": "Повторить загрузку Вех пути",
      "stale": "Показаны последние сохранённые данные",
      "loadingA11y": "Загружаем Вехи пути"
    },
    "a11y": {
      "row": "{{name}}, {{days}}. {{status}}",
      "rowInProgress": "{{name}}, {{days}}. {{status}}, {{progress}}, {{remaining}}",
      "progressBar": "Прогресс до следующей вехи"
    }
  }
}
